import { createFileRoute } from '@tanstack/react-router';
import ExperienceList from '~/containers/ExperienceList';

export const Route = createFileRoute('/experienceList')({
  component: ExperienceList,
  validateSearch(search) {
    return {
      experienceId: search.experienceId as number | undefined,
    };
  },
});
